import { createStorageUtils, openPDF } from '@avanta/shared/utils/storage';
import { STORAGE_PREFIX } from 'constants/storage';
import { type Document } from 'types/appointments';
import { type Report } from 'types/files';

export const toDocumentFormData = (document: Document): FormData => {
  const formData = new FormData();
  formData.append('file', document.file, document.file.name);
  formData.append('title', document.title ?? document.file.name);
  if (document.category) {
    formData.append('category', document.category);
  }
  return formData;
};

const base64ToPdfBlob = (pdfBase64: string): Blob => {
  const binaryString = atob(pdfBase64);
  const byteArray = Uint8Array.from(binaryString, char => char.charCodeAt(0));
  return new Blob([byteArray], { type: 'application/pdf' });
};

export const openReportPdf = async (report: Pick<Report, 'id' | 'type' | 'pdf'>): Promise<void> => {
  await openPDF({
    file: base64ToPdfBlob(report.pdf),
    filename: `${report.id}-${report.type}`,
  });
};

export const { getUserId, getRefreshToken, getAnonymousTokenCookie, setCookieWithoutExpiry } =
  createStorageUtils(STORAGE_PREFIX);
